import {IMGPW} from '@/config';

export const mappings = [
  {
    title: 'InvestiInvestieren',
    content: 'Investieren Sie in einen stetig wachsenden Sektor',
    img: IMGPW + '/franchise_icon_1.png',
  },
  {
    title: 'Agentur',
    content: 'Marktführendes Unternehmen und starke Marke',
    img: IMGPW + '/franchise_icon_2.png',
  },
  {
    title: 'Marginalität',
    content: 'Hohe Marge (von 20 bis 27 %)',
    img: IMGPW + '/franchise_icon_3.png',
  },
  {
    title: 'ZonaBereich',
    content: 'Gebietsexklusivität',
    img: IMGPW + '/franchise_icon_4.png',
  },
];

export const threeButtonMappings = [
  {
    title: 'Bar & enoteca',
    paragraph: `All’interno del locale, il cliente potrà scegliere, acquistare e ottenere informazioni sulle bottiglie inquadrando con l’App le etichette. Il locale è anche la base per le consegne a domicilio.
L'App guiderà il cliente nella scelta tramite un sommelier virtuale. La stessa App ha integrato un programma fedeltà.
Il format è particolarmente adatto alle zone ad alto passaggio e che presentano già altri brand commerciali.`,
    hightlights: [
      `Minimo 35 mq`,
      `Strada di passaggio, no canna fumaria`,
      `No fee di ingresso e nessuna royalty sul venduto`,
      `Costi allestimento: ca. 990 €/Mq`,
      `Possibile finanziare quota parte dell’investimento`,
      `Margine Operativo Lordo: 22%-27%`,
    ],

    img: IMGPW + '/bar_enoteca.jpg',
  },
  {
    title: 'Enoteca con delivery',
    paragraph: `All’interno del locale, il cliente potrà scegliere, acquistare e ottenere informazioni sulle bottiglie inquadrando con l’App le etichette. Il locale è anche la base per le consegne a domicilio.
    L'App guiderà il cliente nella scelta tramite un sommelier virtuale. La stessa App ha integrato un programma fedeltà.
    Il format è particolarmente adatto alle zone ad alto passaggio e che presentano già altri brand commerciali.
    `,
    hightlights: [
      `Minimo 25 mq`,
      `Strada di passaggio`,
      `No fee di ingresso e nessuna royalty sul venduto`,
      `Costi allestimento ca. 750 €/Mq`,
      `Possibile finanziare quota parte dell’investimento`,
      `Margine Operativo Lordo: 20%-24%`,
    ],
    img: IMGPW + '/enoteca.jpg',
  },
  {
    title: 'Pimp my store',
    paragraph: `Se invece hai già un bar o un'enoteca ma ti piacerebbe dargli uno sprint, potrai creare un corner dedicato a Winelivery all’interno del tuo locale: un “Winelivery Point” creato su misura per te. Pimp my store è infatti un accordo “ad hoc” studiato in base alle tue necessità tramite il quale avrai la possibilità di:`,
    ulElements: [
      `Migliorare le tue condizioni di acquisto grazie all’accesso alla centrale d’acquisto di Winelivery, con prodotti esclusivi e prezzi agevolati;`,
      `Inserire elementi distintivi di Winelivery o rinnovare totalmente il layout del tuo bar/enoteca;`,
      `Implementare la tecnologia di Winelivery nel tuo bar/enoteca, con possibilità di consegnare a domicilio in esclusiva nella tua zona.`,
    ],
    hightlights: [],
    img: IMGPW + '/pimp_my_store.png',
  },
];

export const bottomCarouselMappings = [
  {
    title: 'Winelivery Bar & Enoteca Andria',
    subtitle: `Via Regina Margherita 134, Andria`,
    img: IMGPW + '/bar_andria.jpeg',
  },
  {
    title: 'Winelivery Bar & Enoteca Trani',
    subtitle: 'Via Zanardelli 21, Trani',
    img: IMGPW + '/bar_trani_2.jpg',
  },
  {
    title: 'Winelivery Bar Navigli Milano',
    subtitle: `Via Casale 3A, Milano`,
    img: IMGPW + '/bar_milano_navigli.jpg',
  },
  {
    title: 'Winelivery Enoteca Garbatella',
    subtitle: `Via Rosa Guarnieri Carducci 49, Roma`,
    img: IMGPW + '/enoteca_garbatella.jpeg',
  },
  {
    title: 'Winelivery Enoteca Largo Somalia',
    subtitle: `Largo Somalia 45, Roma`,
    img: IMGPW + '/enoteca_roma_somalia.jpeg',
  },
  {
    title: 'Winelivery Enoteca Modica',
    subtitle: 'Via Resistenza Partigiana 180, Modica',
    img: IMGPW + '/bar_modica.jpg',
  },
  {
    title: 'Winelivery Enoteca Monteverde',
    subtitle: `Via di Monte Verde 53D, Roma`,
    img: `${IMGPW}/bar_roma_monteverde.jpg`,
  },
  {
    title: 'Winelivery PoP',
    subtitle: `Corso di Porta Ticinese 60, Milano`,
    img: IMGPW + '/bar_pop.jpg',
  },
  {
    title: 'Palermo',
    subtitle: ``,
    img: IMGPW + '/palermo.jpg',
  },
  {
    title: 'Roma - Viale America',
    subtitle: ``,
    img: IMGPW + '/verona.jpg',
  },
  {
    title: 'Costa Rei',
    subtitle: ``,
    img: IMGPW + '/novara.jpg',
  },
  {
    title: 'Siracusa',
    subtitle: ``,
    img: IMGPW + '/siracusa.jpg',
  },
  {
    title: 'Cagliari',
    subtitle: ``,
    img: IMGPW + '/cagliari.jpg',
  },
  {
    title: 'Cremona',
    subtitle: ``,
    img: IMGPW + '/cremona.jpg',
  },
  {
    title: 'Pomigliano d\'Arco',
    subtitle: ``,
    img: IMGPW + '/pomigliano.jpg',
  },
  {
    title: 'Milano',
    subtitle: ``,
    img: IMGPW + '/milano.jpg',
  },
];
